import type { AppRole } from "@/hooks/useUserRoles";

// Keep client entry points aligned with create_contribution_batch_transaction's role allowlist.
export const CONTRIBUTION_IMPORT_ROLES = [
  "admin",
  "super_admin",
  "platform_super_admin",
  "finance",
  "finance_admin",
  "treasurer",
  "bookkeeper",
] as const satisfies readonly AppRole[];

export function canImportContributions(appRoles: readonly AppRole[]) {
  return appRoles.some((role) => CONTRIBUTION_IMPORT_ROLES.includes(role));
}
